// extracted by mini-css-extract-plugin
export default {"tableStyles":"TotalTimeShareEleTable_tableStyles__XzAfo","title":"TotalTimeShareEleTable_title__QaxDN"};